import { gsap } from 'gsap'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(SplitText)

function initHoverShadowLines() {
    document.querySelectorAll('[data-split-hover-shadow]').forEach((el) => {
        const split = SplitText.create(el, {
            type: 'lines',
            mask: 'lines',
            autoSplit: true,
            linesClass: 'line hover-shadow-line'
        })

        // ✅ Pak het element dat effectief de tekst rendert:
        // - soms is dat een child element
        // - soms is het de line zelf
        const textTargets = split.lines
            .map((line) => line.firstElementChild || line) // fallback naar line zelf
            .filter(Boolean) // filter null/undefined weg

        // als er niets bruikbaar is, skip
        if (!textTargets.length) return

        gsap.set(textTargets, {
            y: 0,
            textShadow: '0px 1.2em 0 rgba(0,0,0,0.4)'
        })

        const tl = gsap.timeline({ paused: true }).to(textTargets, {
            y: '-0.25em',
            textShadow: '0px 0px 0 rgba(0,0,0,0.4)',
            duration: 0.45,
            ease: 'expo.out',
            stagger: 0.06
        })

        el.addEventListener('mouseenter', () => tl.play())
        el.addEventListener('mouseleave', () => tl.reverse())
    })
}

document.addEventListener('DOMContentLoaded', initHoverShadowLines)
